import { render, staticRenderFns } from "./AboutPartner.vue?vue&type=template&id=25fa896b&scoped=true&"
import script from "./AboutPartner.vue?vue&type=script&async=true&lang=js&"
export * from "./AboutPartner.vue?vue&type=script&async=true&lang=js&"
import style0 from "./AboutPartner.vue?vue&type=style&index=0&id=25fa896b&lang=scss&scoped=true&"
import style1 from "./AboutPartner.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fa896b",
  null
  
)

export default component.exports